import {
  AggregateOfImpactByProject,
  getMinimumDisplayQuantity,
  ProjectWithImpactQuantity,
  ImpactType,
  User,
} from "@ecologi/shared";
import { DisplayProject, HowCalculatedModal } from "./HowCalculatedModal";
import { QueryResult } from "react-query";
import { DiversifyImpactCard } from "../DiversifyImpactCard";
import {
  EXPLAINERS,
  NO_IMPACT_TITLES,
  PENDING_TITLES,
  TITLES,
} from "./HowCalculatedModalImpactContent";

const buildRowsForModalTable = <
  T extends Exclude<ImpactType, ImpactType.TREES>
>(
  projectData: ProjectWithImpactQuantity<T>[]
) => {
  const rows: DisplayProject[] = projectData.map(
    ({ impactQuantity, slug, title, location, projectType }) => ({
      type: projectType,
      slug,
      quantity: getMinimumDisplayQuantity(impactQuantity),
      title,
      location,
    })
  );
  return rows;
};

type Props<T extends Exclude<ImpactType, ImpactType.TREES>> = {
  impactType: ImpactType;
  isOpen: boolean;
  aggregateOfUserImpact: QueryResult<AggregateOfImpactByProject<T>>;
  onClose: () => void;
  user: User;
  pendingTotal: number;
};

export const HowCalculatedModalImpact = <
  T extends Exclude<ImpactType, ImpactType.TREES>
>({
  impactType,
  aggregateOfUserImpact,
  isOpen,
  onClose,
  user,
  pendingTotal,
}: Props<T>) => {
  const projects = aggregateOfUserImpact?.data?.projects || [];
  const rows = buildRowsForModalTable(projects);

  return (
    <HowCalculatedModal
      type={impactType}
      noImpactSlot={<DiversifyImpactCard impactType={impactType} />}
      isOpen={isOpen}
      projects={rows}
      onClose={onClose}
      noImpactTitle={NO_IMPACT_TITLES[impactType]}
      title={TITLES[impactType](user, rows.length)}
      pendingTitle={PENDING_TITLES[impactType](pendingTotal)}
      pendingTotal={pendingTotal}
      explanation={EXPLAINERS[impactType]()}
    />
  );
};
